import { getField, updateField } from 'vuex-map-fields';

const LOADING = 'LOADING';
// eslint-disable-next-line no-unused-vars
const SET_PACKAGE_ID = 'SET_PACKAGE_ID';

const state = {
    packageId: null,
    savedCard: null,
    isLoading: false,
};

const actions = {
    /**
     * Set
     * @param commit
     * @returns {Promise<void>}
     */
    async setPackageId({ commit }, id) {
        commit(SET_PACKAGE_ID, id);
    },
};

const mutations = {
    // Add the `updateField` mutation to the
    // `mutations` of your Vuex store instance.
    updateField,
    [LOADING](state) {
        state.isLoading = !state.isLoading;
    },
    [SET_PACKAGE_ID](state, id) {
        state.packageId = id;
    },
};

const getters = {
    // Add the `getField` getter to the
    // `getters` of your Vuex store instance.
    getField,
    packageId: (state) => state.packageId,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
